export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14570.f877a9b8.jpg";